.productFilterSelector {
  display: none;
}

.productFilterContainer {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 16px;
  scrollbar-width: none; /* Firefox */
}

.filterButtons {
  display: flex;
  flex-grow: 1;
  flex-wrap: nowrap;
  min-width: 0;
}

.sortAndAction {
  display: flex;
  gap: 16px;
  margin-left: auto;
  flex-shrink: 0;
}

.productFilterContainer::-webkit-scrollbar {
  display: none;
}

@media all and (--reefer-media-tablet-min) {
  .productFilterSelector {
    display: block;
    margin-bottom: 8px;
  }
}
